import React from "react";
import { Backdrop, CircularProgress, IconButton } from "@mui/material";
import {
  globalMenu,
  loadingTypeStore,
  onSearchStore,
  requestControllerStore,
} from "@shared/libs/Global";
import CloseIcon from "@mui/icons-material/Close";
import { onSearchInfo } from "@shared/type/CommonType";

interface SpinnerProps {
  isLoading: boolean;
}

export default function CommonSpinner({ isLoading }: SpinnerProps) {
  const cd_menu = globalMenu.getState().activeMenuInfo.cd_menu;
  const loadingType = loadingTypeStore((state) =>
    state.getLoadingType(cd_menu)
  );

  return (
    <Backdrop
      open={isLoading}
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "auto",
      }}
    >
      <CircularProgress size={100} />

      {/* 우측 상단 X 버튼 */}
      {loadingType === "search" && (
        <IconButton
          onClick={() => {
            requestControllerStore.getState().abortController(cd_menu);
          }}
          sx={{
            position: "absolute",
            top: 10,
            right: 15,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Backdrop>
  );
}
